export default __webpack_public_path__ + "static/media/flag-nicaragua.163d9b5d.svg";